//สีตามระดับความเร่งด่วน (level จาก isb-api) — ชุดเดียวกับอีเมลแจ้งเตือน
//info = 30–8 วัน · warning = 7–4 วัน · danger = 3–0 วัน · expired = เลยวันหมดอายุ
export const LEVEL_COLORS = {
  info: { dot: "#378ADD", tint: "#E6F1FB", ink: "#0C447C" },
  warning: { dot: "#EF9F27", tint: "#FAEEDA", ink: "#854F0B" },
  danger: { dot: "#E24B4A", tint: "#FCEBEB", ink: "#A32D2D" },
  expired: { dot: "#E24B4A", tint: "#FCEBEB", ink: "#A32D2D" },
};

//สถานะ "ส่งคำขอต่ออายุแล้ว"
export const SENT_COLORS = { tint: "#EAF3DE", ink: "#27500A" };

export const levelColors = (level) => LEVEL_COLORS[level] || LEVEL_COLORS.info;
